import * as vp from 'vopay';
import { JSX, ReactNode, createContext, useContext, useState } from 'react';

type AccountSummary = {
  accountBalance: vp.AccountBalanceResponse | undefined;
  setAccountBalance: (accountBalance: vp.AccountBalanceResponse) => void;
};

export const AccountSummaryContext = createContext<AccountSummary>({
  accountBalance: {
    Success: false,
    ErrorMessage: '',
    AccountBalance: '',
    AvailableFunds: '',
    AvailableImmediately: '',
    Currency: 'CAD',
    PendingFunds: '',
    Reserve: '',
    RollingReserveNSF: '',
    RollingReserveReturns: '',
  },
  setAccountBalance: () => {},
});

export const AccountSummaryProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [accountBalance, setAccountBalance] = useState<vp.AccountBalanceResponse>();

  return (
    <AccountSummaryContext.Provider
      value={{
        accountBalance,
        setAccountBalance,
      }}
    >
      {children}
    </AccountSummaryContext.Provider>
  );
};

export const useAccountSummary = (): AccountSummary => useContext(AccountSummaryContext);
